/**
 * Shared email-validation utility — single source of truth for email syntax
 * validation across the frontend. Consolidates the regex that was previously
 * duplicated across many components (issue #2499).
 *
 * Empty / null / undefined / blank values are treated as VALID ("not provided").
 * Call sites that require a non-empty email must keep their own presence check,
 * e.g. `if (!value || !isValidEmail(value))`.
 */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function isValidEmail(value: string | null | undefined): boolean {
  const trimmed = value?.trim()
  if (!trimmed) {
    return true
  }
  return EMAIL_PATTERN.test(trimmed)
}
